import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const updateChildrensParent = (cardChildren, id, entity) => {
  const hasCardChildren = !!cardChildren && Object.keys(cardChildren).length && cardChildren.props;
  if (hasCardChildren && cardChildren.props.children) {
    const childItems = cardChildren.props.children;
    childItems.length > 1 && childItems[1].forEach(child =>
    // eslint-disable-next-line no-param-reassign
    child.props.options.parent = _objectSpread(_objectSpread({}, child.props.options.parent), {}, {
      itemId: id,
      itemEntity: entity
    }));
  }
};
export default updateChildrensParent;
//# sourceMappingURL=update-childrens-parent.js.map